<div class="layout-footer">
  <div
    class="flex flex-col md:flex-row md:justify-between w-full justify-center items-center gap-1">
    <span class="text-sm text-center">
      Acan Group Admin Dashboard | Version {{ this.version }} | ©
      {{ this.currentYear }} All Rights Reserved
    </span>
    <span class="text-sm"
      >Powered by
      <a target="_blank" href="https://purple.lk/?utm_source=acan-dashboard"
        ><span class="font-[500]">Purple Software</span></a
      ></span
    >
  </div>
</div>
